var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('NavBar'),(_vm.$store.state.username !== null)?_c('NewVisitButton'):_vm._e()],1),_c('router-view',{class:{
      visitInProgress: _vm.visitInSession && _vm.$store.state.username !== null,
      view: !_vm.visitInSession || _vm.$store.state.username === null,
    }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }